<template>
  <div class="answer">
    <div class="top">
      <ul class="index">
        <li>{{ busData.name }}</li>
        <li>得分：{{ busData.score }}</li>
      </ul>
    </div>
    <div class="flexArea">
      <!--左边题目编号区-->
      <div class="left">
        <div class="l-bottom">
          <div class="item">
            <p class="total_score"><b>总分:{{ busData.total_score }}</b></p>
            <p class="pass_score"><b>及格:{{ busData.pass_score }}</b></p>
          </div>
        </div>
        <ul class="l-top">
          <li>
            <a href="javascript:"></a>
            <span>正确</span>
          </li>
          <li>
            <a href="javascript:"></a>
            <span>错误</span>
          </li>
        </ul>
        <div class="l-bottom">
          <div class="item">
            <div>
              <el-row>
                <ul>
                  <li v-for="(item, index) in busData.itemList" :key="item.id">
                    <el-button v-if="item.result === 'right' && index !== this.page" class="correct"
                               @click="goToProblem(index)">{{ index + 1 }}
                    </el-button>
                    <el-button v-if="item.result !== 'right' && index !== this.page" class="fault"
                               @click="goToProblem(index)">{{ index + 1 }}
                    </el-button>
                    <el-button v-if="item.result === 'right' && index === this.page" class="correct_now"
                               @click="goToProblem(index)">{{ index + 1 }}
                    </el-button>
                    <el-button v-if="item.result !== 'right' && index === this.page" class="fault_now"
                               @click="goToProblem(index)">{{ index + 1 }}
                    </el-button>
                  </li>
                </ul>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <!--右边选择答题区-->
      <el-card class="right">
        <div v-for="(item,index) in busData.itemList" :key="item.id" class="content">
          <div v-if="index === page">
            <div v-if="item.question_type === 'single'">
              <div>
                <ul class="topic">
                  <li><span class="orderNumber">{{ index + 1 }}</span></li>
                  <li><span class="question_typeSingle">单选题</span></li>
                  <li><span class="score">( {{ item.score }} 分 )</span></li>
                </ul>
              </div>
              <div class="tip"><p>{{ item.topic }}</p></div>
              <div class="image" v-if="item.picture !== null">
                <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                          :src="file.url" :preview-src-list="[file.url]"></el-image>
              </div>
              <el-radio-group v-model="item.answer" class="choice" size="large" disabled>
                <el-radio v-if="item.option_a" :label="'option_a'"><span
                    style="font-size: 18px">A. {{ item.option_a }}</span></el-radio>
                <el-radio v-if="item.option_b" :label="'option_b'"><span
                    style="font-size: 18px">B. {{ item.option_b }}</span></el-radio>
                <el-radio v-if="item.option_c" :label="'option_c'"><span
                    style="font-size: 18px">C. {{ item.option_c }}</span></el-radio>
                <el-radio v-if="item.option_d" :label="'option_d'"><span
                    style="font-size: 18px">D. {{ item.option_d }}</span></el-radio>
                <el-radio v-if="item.option_e" :label="'option_e'"><span
                    style="font-size: 18px">E. {{ item.option_e }}</span></el-radio>
                <el-radio v-if="item.option_f" :label="'option_f'"><span
                    style="font-size: 18px">F. {{ item.option_f }}</span></el-radio>
              </el-radio-group>
            </div>
            <div class="fill" v-if="item.question_type === 'multiple'">
              <div>
                <ul class="topic">
                  <li><span class="orderNumber">{{ index + 1 }}</span></li>
                  <li><span class="question_typeFill">多选题</span></li>
                  <li><span class="score">( {{ item.score }} 分 )</span></li>
                </ul>
              </div>
              <div class="tip"><p>{{ item.topic }}</p></div>
              <div class="image" v-if="item.picture !== null">
                <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                          :src="file.url" :preview-src-list="[file.url]"></el-image>
              </div>
              <el-checkbox-group v-model="item.answer" class="choice" size="large" disabled>
                <el-checkbox v-if="item.option_a" :label="'option_a'"><span
                    style="font-size: 18px">A. {{ item.option_a }}</span></el-checkbox>
                <el-checkbox v-if="item.option_b" :label="'option_b'"><span
                    style="font-size: 18px">B. {{ item.option_b }}</span></el-checkbox>
                <el-checkbox v-if="item.option_c" :label="'option_c'"><span
                    style="font-size: 18px">C. {{ item.option_c }}</span></el-checkbox>
                <el-checkbox v-if="item.option_d" :label="'option_d'"><span
                    style="font-size: 18px">D. {{ item.option_d }}</span></el-checkbox>
                <el-checkbox v-if="item.option_e" :label="'option_e'"><span
                    style="font-size: 18px">E. {{ item.option_e }}</span></el-checkbox>
                <el-checkbox v-if="item.option_f" :label="'option_f'"><span
                    style="font-size: 18px">F. {{ item.option_f }}</span></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="judge" v-if="item.question_type === 'judge'">
              <div>
                <ul class="topic">
                  <li><span class="orderNumber">{{ index + 1 }}</span></li>
                  <li><span class="question_typeJudge">判断题</span></li>
                  <li><span class="score">( {{ item.score }} 分 )</span></li>
                </ul>
              </div>
              <div class="tip"><p>{{ item.topic }}</p></div>
              <div class="image" v-if="item.picture !== null">
                <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                          :src="file.url" :preview-src-list="[file.url]"></el-image>
              </div>
              <el-radio-group v-model="item.answer" class="choice" size="large" disabled>
                <el-radio :label="'correct'"><span style="font-size: 18px">是</span></el-radio>
                <el-radio :label="'fault'"><span style="font-size: 18px">否</span></el-radio>
              </el-radio-group>
            </div>
            <el-button type="primary" @click="showAnswer = !showAnswer" style="margin: 5px">查看答案</el-button>
            <div v-show="showAnswer">
              <div class="right-answer">正确答案：{{ item.right_answer }}</div>
              <div class="key-question">题解：{{ item.describe }}</div>
            </div>
            <div class="operation">
              <ul class="end">
                <li @click="previous()" v-if="index !== 0" :class="index === 1 ? 'next' : 'before-next'">
                  <span>上一题</span><i class="iconfont icon-previous"></i></li>
                <li @click="toNext()" v-if="index !== busData.itemList.length-1"
                    :class="index === 0 ? 'next' : 'before-next'">
                  <span>下一题</span><i class="iconfont icon-next"></i></li>
              </ul>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>

export default {
  name:"ExamDetailCheck",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      //倒计时
      count:'',
      //倒计时总秒数
      seconds:'',
      // 当前题目的序号等于当前题目的条数
      page: 0,
      time: null, //考试持续时间
      index: 0, //全局index

      busData: {
        total_score: 0,
        time: '',
        name: '',
        pass_score:'',
        create_user_id:'',
        create_user_name:'',
        score:'',
        id: '',
        itemList: []
      },
      //试卷信息
      item: {
        describe:'',
        translate_answer:[]
      },
      showAnswer:false,
      //题号
      orderNumber: 0,
      answer:'',
      picture:'',
    }
  },
  computed: {
    questionSingleList() {
      return this.$store.getters['core/getDictList']('question_single');
    },
    questionJudgeList() {
      return this.$store.getters['core/getDictList']('question_judge');
    },
  },
  created() {
    this.putExamAnswerWithDetail()
  },
  methods: {

    toNext() { //下一题
      // 索引+1；
      this.index ++;
      // page ++
      this.page ++;
    },

    previous() { //上一题
      this.index --;
      this.page --;
    },

    goToProblem(index){ //跳转到指定题目
      this.index = index+1;
      this.page = index;
    },

    //获取已完成考试的具体信息
    async putExamAnswerWithDetail() {
      this.busData.id = this.parentData.id
      this.busData.name = this.parentData.name
      this.busData.time = this.parentData.time
      this.busData.pass_score = this.parentData.pass_score
      this.busData.create_user_id = this.parentData.create_user_id
      this.busData.score = this.parentData.score
      this.busData.create_user_name = await this.$http('ihtExamService.getExamPerson', this.busData)
      this.busData.remark = this.parentData.remark
      this.busData.total_score = this.parentData.total_score
      let params = {id: this.parentData.id}
      let templateData = await this.$http('ihtExamService.putExamAnswerWithDetail', params)
      this.busData.itemList = templateData.itemList || [];
      this.valueToName(this.busData.itemList)
      this.count = this.parentData.time
      this.seconds = this.parentData.time * 60

    },
    //value转化为name
    valueToName(list){
      for (const question of list) {
        if(question.question_type === 'single'){
          for (const questionSingle of this.questionSingleList) {
            if(questionSingle.value === question.answer_single){
              question.right_answer = questionSingle.name
            }
          }
        }
        if(question.question_type === 'judge'){
          for (const questionJudge of this.questionJudgeList) {
            if(questionJudge.value === question.answer_judge){
              question.right_answer = questionJudge.name
            }
          }
        }
        if(question.question_type === 'multiple'){
          var list1 = '';
          for (let rightAnswer of question.answer_multiple) {
            rightAnswer = rightAnswer.trim().replaceAll("\"","")
            for (const questionSingle of this.questionSingleList) {
              if(questionSingle.value === rightAnswer){
                list1 = list1 + questionSingle.name + '、'
              }
            }
          }
          list1 = list1.substring(0, list1.length - 1)
          question.right_answer = list1;
        }
      }
    },
    //结束查卷
    over(){
      this.$fn.closeWindow();
    }

  },

}
</script>

<style scoped lang="less">

.right-answer {
  padding: 10px;
  font-size: 20px;
  color: #ff3d3d;
}
.key-question {
  padding: 10px;
  font-size: 20px;
  color: #4d90ff;
}

.operation .end li {
  cursor: pointer;
  margin: 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 150, 220, 0.99);
  border-radius: 5px;
  width: 100px;
  height: 40px;
  color: #fff;
}
.operation {
  background-color: #fff;
  border-radius: 4px;
  padding: 30px;
  margin-right: 10px;
}
.operation .end {
  display: flex;
  justify-content: left;
  align-items: center;
  color: rgb(39, 118, 223);
}
.content .orderNumber {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 30px;
  background-color: rgb(39, 118, 223);
  color: #fff;
  border-radius: 4px;
  margin-right: 4px;
}

.content .topic {
  display: inline-flex;
  align-items:center;
}

.topic .orderNumber {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 30px;
  background-color: rgb(39, 118, 223);
  color: #fff;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 35px;
}

.topic .question_typeSingle {
  padding: 0 5px 0 5px;
  color: #409eff;
  background-color: #d9ecff;
  font-size: 22px;
}

.topic .question_typeFill {
  padding: 0 5px 0 5px;
  color: #e6a23c;
  background-color: #faecd8;
  font-size: 22px;
}

.topic .question_typeJudge {
  padding: 0 5px 0 5px;
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 22px;
}

.topic .score{
  margin-left: 4px;
  font-size: 25px;
}

.choice{
  margin-left: 30px;
}
.content .el-radio-group {
  display: flex;
  flex-direction:column;
}

.content .el-radio-group el-radio {
  margin-left: 10px;
}

.content .el-checkbox-group{
  display: flex;
  flex-direction:column;
}

.el-radio-group {
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
  font-size: 0;
}

.tip p{
  margin: 5px;
  font-size: 20px;
  text-align: left;
}

.right .title p {
  display: flex;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
  font-size: 20px;
}

.flexArea {
  display: flex;
}
.flexArea .right {
  flex: 1;
}

.right .title span {
  font-size: 20px;
}

.right .title {
  margin-right: 30px;
  padding-right: 40px;
  display: flex;
  margin-top: 10px;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
}

.l-bottom .final {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  background-color: rgb(39, 118, 223);
  width: 240px;
  margin: 20px 0 20px 10px;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.l-bottom {
  margin: 5px 5px 0 5px;
  background-color: #fff;
  box-shadow: 0 0 5px -3px rgba(0,0,0,5);
}

.l-bottom .item {
  display: inline-block;
  background-color: #fff;
  flex-direction: column;
}

.l-bottom .item .total_score {
  margin-bottom: 8px;
  color: #4c8adc;
  margin-left: 10px;
  display: inline-block;
  letter-spacing: 2px;
  font-size: 20px;
}

.l-bottom .item .pass_score {
  margin-bottom: 8px;
  color: #4c8adc;
  margin-left: 30px;
  display: inline-block;
  letter-spacing: 2px;
  font-size: 20px;
}

.l-bottom .item .score {
  margin-bottom: 8px;
  color: #e6a23c;
  margin-left: 10px;
  letter-spacing: 2px;
  font-size: 18px;
}

.l-bottom .item .listing {
  margin-bottom: 8px;
  color: #000;
  margin-left: 10px;
  letter-spacing: 2px;
}

.l-bottom .item ul {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
}

.l-bottom .item li {
  margin-left: 8px;
  margin-bottom: 10px;
}

.l-bottom .item ul li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  text-align: center;
}
.left {
  width: 260px;
  height: 100%;
  margin: 10px 10px 10px 10px;
}

.left .l-top {
  display: flex;
  justify-content: space-around;
  padding: 10px 0 2px 2px;
  border: #fff;
  border-radius: 4px;
  margin-top: 5px;
  background-color: #fff;
  box-shadow: 0 0 5px -3px rgba(0,0,0,5);
}

.left .l-top li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.left .l-top li a {
  display: inline-block;
  padding: 12px;
  border-radius: 50%;
  background-color: #12EA0BFF;
  color: #fff;
}

.left .l-top li:nth-child(2) a {
  padding: 12px;
  background-color: #fc0202;
  border: none;
}

.correct{
  width: 35px;
  height: 35px;
  background-color:#12EA0BFF;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fault{
  width: 35px;
  height: 35px;
  background-color:#fc0202;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.correct_now{
  width: 39px;
  height: 39px;
  color: #fff;
  border-color: #1879fa;
  border-width: 4px;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  background-color: #12EA0BFF;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fault_now{
  width: 39px;
  height: 39px;
  color: #fff;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  border-color: #1879fa;
  border-width: 4px;
  background-color: #fc0202;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.answer .top {
  background-color: rgb(54, 106, 175);
}

.answer .top .index {
  display: flex;
  justify-content:space-between;
  color: #fff;
  padding: 15px;
  font-size: 22px;
}

.answer .top .index li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.answer {
  padding-bottom: 30px;
}

</style>